import {useQuery} from '@tanstack/react-query'

import {getMenuItemDetail} from '@/lib/food-grubhub/foodGrubhubService'
import type {MenuItemDetailQuery} from '@/lib/food-grubhub/foodRestaurantDetailModel'

const useGrubhubMenuItemDetail = (params: MenuItemDetailQuery, token: string) => {
  return useQuery({
    queryKey: ['category_detail', params, token],
    queryFn: async () =>
      getMenuItemDetail({
        restaurantId: params.restaurantId ?? '',
        menuItemId: params.menuItemId ?? '',
        time: params.time ?? 0,
        hideUnavailableMenuItems: params.hideUnavailableMenuItems ?? true,
        orderType: params.orderType ?? 'standard',
        locationMode: params.locationMode ?? '',
        version: params.version ?? 4,
        includeWeightedItemsData: params.includeWeightedItemsData ?? true,
        location: params.location ?? '',
        token,
        signal: undefined,
      }),
    enabled: !!token,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 5,
  })
}

export default useGrubhubMenuItemDetail
